import { h, Component } from 'preact'
import ProductsAPI from '../api/ProductsAPI'
import validate from '../helpers/validate'
import Content from '../components/Content'
import Preview from '../components/Preview'
import Form from '../components/Form'
import Loader from '../components/Loader'
import scrollMonitor from 'scrollmonitor'
import { numberFormat } from '../../woocommerce/NumberFormat'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

/**
 * 1 - Fetch all logomatten
 * 2 - User fills in form
 * 3 - Find matching logomat based on user input (use, type and thickness)
 * 4 - Calculcate price based on matching logomat (price m2) + user input (length/width/cutter/corners)
 */

class App extends Component {

  constructor(props) {
    super(props)

    this.state = {
      products: [],
      currentProduct: {},
      targetPrice: 'Vul velden in',
      fetchError: false,
      priceError: false,
      isLoading: true,
      formIsValid: false,
      sendingForm: false,
      formControls: {
        use: { //radio
          value: '',
          valid: false, //set to true if give default value
          validationRules: {
            isRequired: true,
          },
          touched: false,
          error: '',
          options: [
            { value: 'Binnenmatten', displayValue: 'Binnen' },
            { value: 'Buitenmatten', displayValue: 'Buiten' }
          ]
        },
        type: { //select
          value: '',
          placeholder: 'Kies een mat',
          valid: false,
          validationRules: {
            isRequired: true,
          },
          touched: false,
          error: '',
          options: [] //get filled dynamically
        },
        thickness: { //radio
          value: '',
          valid: false,
          validationRules: {
            isRequired: true,
          },
          touched: false,
          error: '',
          options: [] //get filled dynamically
        },
        rubberEdge: { //radio
          value: 'Nee',
          valid: true,
          validationRules: {
            isRequired: false,
          },
          touched: false,
          error: '',
          options: [
            { value: 'Ja', displayValue: 'Ja' },
            { value: 'Nee', displayValue: 'Nee' }
          ]
        },
        length: { //number
          value: '',
          placeholder: 'Lengte (cm)',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 1,
            min: 1,
            max: 9999,
            step: '0.1'
          },
          touched: false,
          error: ''
        },
        width: { //number
          value: '',
          placeholder: 'Breedte (cm)',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 1,
            min: 1,
            max: 9999,
            step: '0.1'
          },
          touched: false,
          error: ''
        },
        hasCorners: { //radio
          value: 'Nee',
          valid: true, //set to true if give default value
          validationRules: {
            isRequired: true,
          },
          touched: true,
          error: '',
          options: [
            { value: 'Ja', displayValue: 'Ja' },
            { value: 'Nee', displayValue: 'Nee' }
          ]
        },
        corners: { //number
          value: '0',
          placeholder: '0',
          valid: true,
          validationRules: {
            isRequired: true,
            minLength: 1,
            min: 0,
            max: 10,
            step: '1'
          },
          touched: true,
          error: ''
        },  
        cutter: { //radio
          value: 'Nee',
          valid: true, //set to true if give default value
          validationRules: {
            isRequired: true,
          },
          touched: true,
          error: '',
          options: [
            { value: 'Ja', displayValue: 'Ja (+ 3,95)' },
            { value: 'Nee', displayValue: 'Nee' }
          ]
        },
        file: { //file
          value: '',
          fileName: '',
          valid: true,
          validationRules: {
            maxSize: '4000000', //4MB
          },
          touched: false,
          error: '',
          accept: '.doc,.docx,.pdf,.jpg,.png'
        },
        firstname: { //text
          value: '',
          placeholder: 'Voornaam*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        lastname: { //text
          value: '',
          placeholder: 'Achternaam*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        company: { //text
          value: '',
          placeholder: 'Bedrijfsnaam',
          valid: true,
          validationRules: {},
          touched: false,
          error: ''
        },
        phone: { //text
          value: '',
          placeholder: 'Telefoon*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        email: { //email
          value: '',
          placeholder: 'E-mailadres*',
          valid: false,
          validationRules: {
            isRequired: true,
            isEmail: true
          },
          touched: false,
          error: ''
        },
        address: { //text
          value: '',
          placeholder: 'Straat en huisnummer*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        zip: { //text
          value: '',
          placeholder: 'Postcode*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        city: { //text
          value: '',
          placeholder: 'Plaats*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        message: { //textarea
          value: '',
          placeholder: 'Heeft u nog opmerkingen?',
          valid: true,
          validationRules: {},
          touched: false,
          error: ''
        },
      }
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleRemoveFile = this.handleRemoveFile.bind(this)
    this.isMatchingProduct = this.isMatchingProduct.bind(this)
    this.calculateTargetPrice = this.calculateTargetPrice.bind(this)
    this.getTypeOptions = this.getTypeOptions.bind(this)
    this.getThicknessOptions = this.getThicknessOptions.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.fetchProducts()
    this.handleScroll()
  }

  /**
   * Fetch all logo matten
   */
  fetchProducts() {
    this.setState({ isLoading: true })

    ProductsAPI.all()
    .then(response => {
      return response.json()
    })
    .then(data => {
      this.setState({
        products: [...this.state.products, ...data],
        isLoading: false
      })
    }).catch(error => {
      this.setState({
        fetchError: true,
        isLoading: false
      })
      throw Error(`Fetching products failed: ${error}`)
    })
  }

  /**
   * Handle scroll
   */
  handleScroll() {
    const monitor = document.querySelector('.js-personalizer-preview')
    const watcher = scrollMonitor.create(monitor)

    watcher.lock(); // ensure that we're always watching the place the element originally was

    watcher.stateChange(() => {
      if (watcher.isInViewport || (!watcher.isInViewport && watcher.isBelowViewport) ) {
        if (monitor.classList.contains('active')) {
          monitor.classList.remove('active')
        }
      } else {
        if (!monitor.classList.contains('active')) {
          monitor.classList.add('active')
        }
      }
    })
  }

  /**
   * Handle form submit
   */
  handleSubmit(e) {
    e.preventDefault()
    this.setState({
      sendingForm: true
    })
    window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
      credentials: 'same-origin',
      method: 'post',
      body: new window.FormData(e.target)
    }).then((response) => {
      return response.json()
    }).then((r) => {
      window.dataLayer.push({
        'event': 'personalizeDoorMat',
        'product': this.state.currentProduct.title,
        'price': this.state.targetPrice,
        'thickness': this.state.formControls.thickness.value,
        'rubberEdge': this.state.formControls.rubberEdge.value
      })
      setTimeout(() => {
        window.location = '/zakelijk/mat-personaliseren/bedankt/'
      }, 1000)
    })
  }

  /**
   * Handle form changes
   */
  handleChange(e) {

    // Grab the current form element
    const name  = e.target.name
    const value = e.target.value
    const files = e.target.files
    const fileName = (files && files.length > 0) ? files[0].name : '' 
    const updatedControls = { ...this.state.formControls }
    const updatedFormElement = { ...updatedControls[name] }

    // Update the current form element
    const validation = validate(value, files, updatedFormElement.validationRules)
    updatedFormElement.value = value
    updatedFormElement.valid = validation.status
    updatedFormElement.error = validation.message
    updatedFormElement.touched = true
    if (fileName) { updatedFormElement.fileName = fileName }
    updatedControls[name] = updatedFormElement

    /**
     * Reset 'type' if new 'use' has been chosen, 
     * because the type options will be recreated dynamically.
     */
    if ( name === 'use') {
      updatedControls.type.value = ''
      updatedControls.type.valid = false
      updatedControls.type.touched = false
      updatedControls.type.options = []
    }

    /**
     * Reset 'thickness' if new 'use' or 'type' has been chosen, 
     * because the thickness options will be recreated dynamically.
     */
    if ( name === 'use' || name === 'type' ) {
      updatedControls.thickness.value = ''
      updatedControls.thickness.valid = false
      updatedControls.thickness.touched = false
      updatedControls.thickness.options = []
    }

    /**
     * Loop through all form controls valid status, 
     * to determine whether form is valid or not.
     */
    let formIsValid = true

    for (let el in updatedControls) {
      formIsValid = updatedControls[el].valid && formIsValid
    }

    // Set new state
    this.setState({
      formControls: updatedControls,
      formIsValid: formIsValid
    })

    /**
     * Try to find a matching product based on user input,
     * and calculate target price afterwards
     */
    this.findMatchingProduct()

    /**
     * Find type select options based on user input (use)
     */
    this.getTypeOptions()
    this.getThicknessOptions()

  }

  /**
   * Handle removal of file value
   * if click 'verwijderen'.
   */
  handleRemoveFile() {
    const formControls = this.state.formControls
    formControls.file.value = ''
    formControls.file.valid = false
    formControls.file.error = ''
    formControls.file.touched = false

    this.setState({
      formIsValid: false,
      formControls: formControls
    })
  }

  /**
   * Find a matching mat 
   * based on the entered use, type and thickness.
   */
  findMatchingProduct() {
    const { products, formControls } = this.state

    /**
     * Return empty object 
     * if user has NOT entered all required values to find a match
     */
    if ( 
      formControls.use.value === '' ||
      formControls.type.value === '' || 
      formControls.thickness.value === ''
    ) {
      return this.setState({
        currentProduct: {},
        targetPrice: 'Geen product match'
      })
    }

    /**
     * Return matching product object OR empty object 
     * if user has entereed all required values to find a match
     */
    const currentProduct = products.find(this.isMatchingProduct) ? products.find(this.isMatchingProduct) : {}

    this.setState( () => {
      return {
        currentProduct: currentProduct
      }
    }, this.calculateTargetPrice )
  }

  /**
   * Check if there's a product match
   * based on the entered use, type and thickness.
   * 
   * @return boolean
   */
  isMatchingProduct(product) {
    const { formControls } = this.state

    const use = product.use.includes(formControls.use.value)
    const type = product.type.includes(formControls.type.value)
    const thickness = product.thickness.includes(formControls.thickness.value)
    
    return (use && type && thickness)
  }

  /**
   * Calculate target price
   */
  calculateTargetPrice() {
    const { currentProduct, formControls } = this.state

    /**
     * If no matching product
     */
    if ( ! currentProduct.id ) {
      return this.setState({
        targetPrice: 'Geen product match'
      })
    }

    let price = currentProduct.price
    const cutterPrice = currentProduct.cutter_price
    const cornerPrice = currentProduct.corner_price

    /**
     * If product lacks a price.
     */
    if ( ! price ) {
      return this.setState({
        targetPrice: 'Op aanvraag*'
      })
    }

    /**
     * If user has NOT entered dimensions
     */
    if ( 
      formControls.length.value === '' ||
      formControls.length.value < 1 ||
      formControls.width.value  === '' ||
      formControls.width.value  < 1
    ) {
      return this.setState({
        targetPrice: 'Vul dimensies in'
      })
    }

    /**
     * Calculate dimensions price
     */
    price = parseFloat(price)
    const length = parseFloat(formControls.length.value)
    const width = parseFloat(formControls.width.value)

    let targetPrice = ( (length / 100) * (width / 100) ) * price

    /**
    * Add cutter price if one exists
    * and if user has selected one
    */
    if ( cutterPrice && formControls.cutter.valid && formControls.cutter.value === 'Ja' ) {
      targetPrice = targetPrice + parseFloat(cutterPrice)
    }

    /**
    * Add corner price if one exists
    * and if user has selected one
    */
    if ( cornerPrice && formControls.corners.valid && formControls.corners.value !== '' ) {
      targetPrice = targetPrice + (parseFloat(cornerPrice) * parseFloat(formControls.corners.value))
    }

    // Return error if invalid price
    if ( numberFormat(targetPrice, 2, ',', '.') === '0,00' ) {
      this.setState({
        targetPrice: 'Prijs kon niet berekend worden.',
        priceError: true
      })
      throw Error(`Price failed to calculate: returned 0,00`)
    }

    // Set price
    this.setState({
      targetPrice: numberFormat(targetPrice, 2, ',', '.') 
    })
  }

  /**
   * Build the formControls.type options
   * based on user input.
   */
  getTypeOptions() {
    const { products, formControls } = this.state

    // Return early if user has NOT entered required formControls.use
    if ( formControls.use.value === '' ) return

    // Return product with a matching 'use'
    const matchingProducts = products.filter((product) => {
      return product.use.includes(formControls.use.value)
    })

    /**
     * Build all formControls.type options from the matching products
     */
    const types = matchingProducts.map(product => product.type) //has duplicates
    const uniqueTypes = [...new Set( types.flat() )] //remove duplicates
    let options = []

    ;[...uniqueTypes].forEach(type => {
      options.push({
        value: type, displayValue: type
      })
    })

    /**
     * Set new formControls.type options 
     */
    formControls.type.options = options
    this.setState({ formControls: formControls })
  }

  /**
   * Build the formControls.thickness options
   * based on user input.
   */
  getThicknessOptions() {
    const { products, formControls } = this.state

    // Return early if user has NOT entered required formControls.type
    if ( formControls.type.value === '' ) return

    // Return product with a matching 'type'
    const matchingProducts = products.filter((product) => {
      return product.type.includes(formControls.type.value)
    })

    /**
     * Build all formControls.thickness options from the matching products
     */
    const thicknesses = matchingProducts.map(product => product.thickness) //has duplicates
    const uniqueThicknesses = [...new Set( thicknesses.flat() )] //remove duplicates
    let options = []

    ;[...uniqueThicknesses].forEach(thickness => {
      options.push({
        value: thickness, displayValue: `${thickness} mm`
      })
    })

    /**
     * Set new formControls.type options 
     */
    formControls.thickness.options = options
    this.setState({ formControls: formControls })
  }

  /**
   * Render
   */
  render() {
    let { formIsValid, formControls, currentProduct, isLoading, fetchError, priceError, targetPrice, sendingForm } = this.state
    return (
      <div className="c-personalizer u-flex u-flex-sb">

        <div className="c-personalizer__left">
          <Content />
          <Preview 
            product={currentProduct}
            formControls={formControls}
            targetPrice={targetPrice}
          />
        </div>

        { fetchError ? (
          <div className="c-personalizer__right">
            <div class="c-personalizer__app-error">App kon niet geladen worden. Ververs a.u.b. de pagina.</div>
          </div>
        ) : null }

        { priceError ? (
          <div className="c-personalizer__right">
            <div class="c-personalizer__app-error">Er is iets misgegaan met de prijsberekening. Ververs a.u.b. de pagina.</div>
          </div>
        ) : null }

        { ! fetchError && ! priceError ? (
          
          <div className="c-personalizer__right">
            { isLoading ? (
              <Loader />
            ) : (
              <Form 
                formControls={formControls} 
                formIsValid={formIsValid} 
                currentProduct={currentProduct} 
                targetPrice={targetPrice}
                handleChange={this.handleChange}
                handleRemoveFile={this.handleRemoveFile}
                handleSubmit={this.handleSubmit}
                sendingForm={sendingForm}
              />
            ) }
          </div>

        ) : null }  

      </div>
    )
  }
}

export default App

/** https://medium.com/@agoiabeladeyemi/the-complete-guide-to-forms-in-react-d2ba93f32825 */


// WEBPACK FOOTER //
// ./src/js/personalizer/containers/App.js